/** @file CommandCalls as the PendingCommands a gesture release returns (mesh edits mint no ids). */
import type { CommandCall } from '@pose2d/format/types';
import type { PendingCommand } from '../../stores/types';

/** Same name and input, `ids: []` (no command of this area creates an entity). */
export function pendingOf(calls: readonly CommandCall[]): PendingCommand[] {
  return calls.map((c) => ({ name: c.name, input: c.input, ids: [] }));
}
